var $69371b06c393f3b9$exports = {};
$69371b06c393f3b9$exports = {
    "Empty": `Vazio`
};


export {$69371b06c393f3b9$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
